import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/tercero/importer/terceroImporterActions';

export default importerReducers(actions);
